


































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { PostChangePassword } from "@/request/common";
@Component({})
export default class Name extends Vue {
  private ifShowPassword: any = false;
  private paw: any = "";
  private repaw: any = "";
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private get curPro() {
    return this.$store.state.curPro;
  }
  private goSetting() {
    this.$router.push("/main/teacher/help");
  }
  private goWenda() {
    this.$router.push("/main/teacher/qa-list");
  }
  private handleCommand(e: string) {
    if (e == "智能练习报告") {
      this.$router.push("/main/shixun/practice-report");
    } else if (e == "修改密码") {
      this.ifShowPassword = true;
      this.paw = "";
      this.repaw = "";
    }
  }
  private exit() {
    this.$confirm("确定要退出吗？", "退出", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      localStorage.removeItem("token");
      this.$router.replace("/login");
    });
  }
  private editPaw() {
    const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{7,})$/;
    if (!this.paw) {
      this.$message.warning("新密码不能为空");
      return;
    }
    if (!this.repaw) {
      this.$message.warning("重复新密码不能为空");
      return;
    }
    if (!reg.test(this.paw)) {
      this.$message.warning(
        "密码字符数须大于6位，且包含字母（不区分大小写）、数字"
      );
      return;
    }
    if (!reg.test(this.repaw)) {
      this.$message.warning(
        "密码字符数须大于6位，且包含字母（不区分大小写）、数字"
      );
      return;
    }
    if (this.paw !== this.repaw) {
      this.$message.error("两次输入的密码不一致，请重新输入");
      return;
    }
    const params: any = {
      新密码: this.paw,
    };
    PostChangePassword(this, params).then(() => {
      this.$message.success("修改成功");
      localStorage.removeItem("token");
      this.$router.replace("/login");
    });
  }
  private mounted() {}
}
